export default __webpack_public_path__ + "static/media/WelcomePageBG.b6e73601.jpg";